import React from 'react';

import classnames from 'classnames';

import FlexLayout from 'common/components/core/FlexLayout/FlexLayout';
import './Collapse.scss';

export type CollapseProps = {
  isOpen?: boolean;
  className?: string;
  ['data-test']?: string;
};

export default function Collapse(props: React.PropsWithChildren<CollapseProps>) {
  const classNames = classnames('collapse', props.className, props.isOpen ? 'collapse--open' : undefined);
  return (
    <FlexLayout className={classNames} role="region">
      {props.children}
    </FlexLayout>
  );
}
